import ModalConfirmPhoneNumber from 'Components/ModalConfirmPhoneNumber/ModalConfirmPhoneNumber'
import PropTypes from 'prop-types'

export const ModalTrustedSmsSenderCodeRequest = ({
  show,
  number,
  handleCancel,
  handleConfirm
}) => {
  return (
    <ModalConfirmPhoneNumber
      show={show}
      onConfirm={handleConfirm}
      number={number}
      onCancel={handleCancel}
    />
  )
}

ModalTrustedSmsSenderCodeRequest.propTypes = {
  show: PropTypes.bool,
  number: PropTypes.any,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}
